/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaCreateGiftCardViewProps } from './citta-create-gift-card';

export default (props: ICittaCreateGiftCardViewProps) => {
    const { GiftCardCreationModuleProps, GiftCardWrapNodeProps, GiftCardErrorNodeProps, GiftCardRight, GiftCardErrors, GiftCardAddToCartErrorsNodeProps, GiftCardAddToCartErrors } = props;
    // const { resources } = props;
    return (
        <Module {...GiftCardCreationModuleProps}>
            <Node {...GiftCardWrapNodeProps}>
                { GiftCardRight }
            </Node>
            <Node {...GiftCardErrorNodeProps}>
               { GiftCardErrors }
            </Node>
            <Node {...GiftCardAddToCartErrorsNodeProps}>
                { GiftCardAddToCartErrors }
            </Node>
        </Module>
    );
};
